import styled from 'styled-components';


export const StyledCompTitle = styled.h1`
    color: ${props => props.theme.headlineColor};        
`;

export const StyledTitleIcon = styled.span`
    color: ${props => props.theme.pageBackground};
    background-color: ${props => props.theme.brandColor};
`;

export const StyledToolboxIcon = styled.span`
    color: ${props => props.theme.brandColor};
`;



// WEBPACK FOOTER //
// ./components/utils/Styled/title.js